module.exports = __webpack_public_path__ + "img/hero-erp.1db73a36.jpg";